export default "__VITE_ASSET__aRYJUwOW__"